import Image from "next/image";
import React from "react";

const DoctorMbbsMdAmericaMobile = () => {
  return (
    <>
      <div
        className="px-3 py-6 relative"
        style={{
          boxShadow:
            "99px 131px 46px 0px rgba(4, 84, 175, 0.00), 64px 84px 42px 0px rgba(4, 84, 175, 0.01), 36px 47px 35px 0px rgba(4, 84, 175, 0.05), 16px 21px 26px 0px rgba(4, 84, 175, 0.09), 4px 5px 14px 0px rgba(4, 84, 175, 0.10)",
        }}
      >
        <div className="flex items-center justify-center gap-2">
          <Image
            src="/healthcare/doctors/Celender.png"
            width={18}
            height={18}
            alt="calender"
            className=""
          />
          <p className="text-base text-[#1772EA] trackiing-[-0.64px] font-semibold">
            Years 1-3
          </p>
        </div>
        <h2 className="text-center text-[28px] font-semibold tracking-[-1.12px] text-black">
          Study Pre-Med & Med in{"  "}
          <span className="md:pb-0 bg-[linear-gradient(96deg,#39f_8.49%,#ffba08_87.26%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent] inline-block pr-[5px] italic">
            America
          </span>
          <br />
          <span className="text-xl text-black tracking-[-0.8px]">{`(Caribbean)`}</span>
        </h2>
        <div className="bg-[#F7FBFF] rounded-xl px-4 py-3 flex flex-col gap-2">
          <div className="flex gap-2 items-center">
            <Image
              src="/healthcare/doctors/learn.png"
              width={22}
              height={22}
              alt="ellipse"
            />
            <p className="text-black text-sm font-semibold tracking-[-0.56px]">
              Study the U.S. medical curriculum from Day 1
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <Image
              src="/healthcare/doctors/study.png"
              width={22}
              height={22}
              alt="ellipse"
            />
            <p className="text-black text-sm font-semibold tracking-[-0.56px]">
              learn from the U.S. medical faculty
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <Image
              src="/healthcare/doctors/prepare.png"
              width={22}
              height={22}
              alt="ellipse"
            />
            <p className="text-black text-sm font-semibold tracking-[-0.56px]">
              Work as a licensed U.S. Doctor
            </p>
          </div>
        </div>
        <div className="mt-3 flex gap-2 items-center justify-center">
          <Image
            src="/healthcare/doctors/george_university.png"
            height={170}
            width={170}
            alt="george school"
          />
          <Image
            src="/healthcare/doctors/james_school.png"
            height={170}
            width={170}
            alt="james school"
          />
        </div>
      </div>
    </>
  );
};

export default DoctorMbbsMdAmericaMobile;
